/**
 * O destino pretendido antes de a pessoa ser mandada para a entrada.
 *
 * Ele vem do estado da navegação, que é interno ao roteador — mas continua sendo dado que
 * chegou de fora do componente, então é validado como tal: só caminho absoluto do próprio
 * portal passa. `//outro-site` e `http://…` são endereços externos disfarçados de caminho e
 * são descartados, senão a tela de entrada vira um redirecionador aberto.
 */
export function destinoSeguro(estado: unknown): string | null {
  if (typeof estado !== "object" || estado === null) return null;
  const de = (estado as { de?: unknown }).de;
  if (typeof de !== "string" || de.length === 0) return null;
  if (!de.startsWith("/") || de.startsWith("//")) return null;
  return de;
}

/** A área a que um caminho pertence: `/admin` é do time interno, `/app` é do cliente. */
function areaDoCaminho(caminho: string): "interno" | "cliente" | null {
  const semConsulta = caminho.split(/[?#]/, 1)[0] ?? "";
  if (semConsulta === "/admin" || semConsulta.startsWith("/admin/")) return "interno";
  if (semConsulta === "/app" || semConsulta.startsWith("/app/")) return "cliente";
  return null;
}

/**
 * O destino pretendido, desde que pertença à área do perfil que ACABOU de entrar.
 *
 * Defeito 3.1: o `de` sobrevivia a um logout e mandava a próxima pessoa — de qualquer perfil —
 * para a área da anterior. O interno caía na esteira do cliente, sem as permissões dele. O
 * destino depois de entrar é decidido pelas credenciais informadas; um endereço de outra área
 * é descartado, e o link profundo legítimo (mesma área) continua valendo.
 */
export function destinoAposEntrar(estado: unknown, interno: boolean): string | null {
  const pretendido = destinoSeguro(estado);
  if (!pretendido) return null;
  const area = areaDoCaminho(pretendido);
  if (area === null) return pretendido;
  return area === (interno ? "interno" : "cliente") ? pretendido : null;
}
